import { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline } from "react-leaflet";
import L from "leaflet";
import { fmtMiles } from "@/lib/constants";

function icon(html) {
  return L.divIcon({ html, className: "", iconSize: [40, 40], iconAnchor: [20, 20] });
}
const truckIcon = icon(
  `<div class="truck-marker"><div class="ring"></div>
   <div style="width:32px;height:32px;border-radius:50%;background:#d15d36;border:3px solid #fff;box-shadow:0 3px 8px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;color:#fff;font-size:15px">🚚</div></div>`
);
const destIcon = icon(
  `<div style="width:22px;height:22px;border-radius:50%;background:#3d684d;border:3px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.3)"></div>`
);

function Fit({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 1) map.setView(points[0], 12);
    else if (points.length > 1) map.fitBounds(points, { padding: [60, 60], maxZoom: 13 });
  }, [map, points]);
  return null;
}

export default function FleetMap({ trucks, height = 520, onSelect }) {
  const points = useMemo(() => {
    const p = [];
    trucks.forEach((t) => {
      if (t.current_lat != null) p.push([t.current_lat, t.current_lng]);
      p.push([t.dest_lat, t.dest_lng]);
    });
    return p;
  }, [trucks]);

  const center = points[0] || [40.73, -74.0];

  return (
    <div className="overflow-hidden rounded-2xl border border-stark-border" style={{ height }} data-testid="fleet-map">
      <MapContainer center={center} zoom={11} style={{ height: "100%", width: "100%" }} scrollWheelZoom>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" />
        {trucks.map((t) => (
          <div key={t.id}>
            {t.route_geometry && t.route_geometry.length > 1 && (
              <Polyline positions={t.route_geometry} pathOptions={{ color: "#d15d36", weight: 4, opacity: 0.7 }} />
            )}
            <Marker position={[t.dest_lat, t.dest_lng]} icon={destIcon}>
              <Popup>{t.customer_name}<br />{t.address}</Popup>
            </Marker>
            {t.current_lat != null && (
              <Marker position={[t.current_lat, t.current_lng]} icon={truckIcon}>
                <Popup>
                  <b>{t.driver_name || "STARK Truck"}</b><br />
                  → {t.customer_name}<br />
                  {t.eta_minutes != null ? `ETA ~${Math.round(t.eta_minutes)} min${t.distance_km != null ? ` · ${fmtMiles(t.distance_km)}` : ""}` : "Locating…"}
                  <br />
                  <button
                    type="button"
                    onClick={() => onSelect?.(t)}
                    style={{ color: "#d15d36", fontWeight: 600, cursor: "pointer", background: "none", border: "none", padding: 0, marginTop: 4 }}
                  >
                    View job details →
                  </button>
                </Popup>
              </Marker>
            )}
          </div>
        ))}
        <Fit points={points} />
      </MapContainer>
    </div>
  );
}
